import {
  useUpdateMaterialStatus as useDomainUpdateMaterialStatus,
  Material,
  MaterialsQueryKey,
  MaterialWithRecipesQueryKey,
  MaterialsRecipesQueryKey
} from '@domain/materials'
import {useNotification} from '@hconnect/uikit/src/common'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {settingsQueryClient} from '../../../common/providers'
import {invalidateSettingsQuery} from '../../../common/providers/ApiInterface'
import {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

export const useUpdateMaterialStatus = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useDomainUpdateMaterialStatus({
    onError: (error) => {
      notifyIfErrorMessage(
        (error.response?.data as ErrorResponse | undefined)?.detail,
        raiseError,
        notify
      )
    },
    onSuccess: (_, variables) => {
      notify('success', t('success.updateMaterialStatus'))

      const prevMaterials = settingsQueryClient.getQueryData<Material[]>([
        MaterialsQueryKey,
        variables.plantCode
      ])

      if (prevMaterials) {
        void settingsQueryClient.setQueryData(
          [MaterialsQueryKey, variables.plantCode],
          prevMaterials.map((m) => {
            if (m.id !== variables.materialId) return m
            return {...m, isActive: variables.isActive}
          })
        )
      }

      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialWithRecipesQueryKey],
        refetchType: 'all'
      })
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialsRecipesQueryKey],
        refetchType: 'all'
      })
      invalidateSettingsQuery('assets')
    }
  })
}
